module.exports = __webpack_public_path__ + "img/ic-arrow-up.798afe8d.svg";